import { render } from "./SpeakerDetail.vue?vue&type=template&id=af076982&scoped=true"
import script from "./SpeakerDetail.vue?vue&type=script&lang=js"
export * from "./SpeakerDetail.vue?vue&type=script&lang=js"

import "./SpeakerDetail.vue?vue&type=style&index=0&id=af076982&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af076982"]])

export default __exports__